import { IShopGroup } from '../../interfaces/shop-groups.interface'

export interface ShopGroupsStateModel {
  groups: IShopGroup[]
}
